// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2tFZ4","empty":"ModalGraph_empty__3q6Bz"};